<template>
  <component class="media-gallery-thumbnail" :is="mediaTypesHash[item.type]" :media="item" :width="170">
  </component>
</template>

<script>

import VideoThumbnail from '@/components/VideoThumbnail';
import ImageThumbnail from '@/components/ImageThumbnail';

const mediaTypesHash = {
  video: VideoThumbnail,
  image: ImageThumbnail,
};

export default {
  name: 'MediaGalleryThumbnail',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mediaTypesHash,
    };
  },
};

</script>



// WEBPACK FOOTER //
// src/components/MediaGalleryThumbnail.vue